import Header from './Header';
import Footer from './Footer';
import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPartnerInfo, setPartnerStore, setPartnerTrackCode } from '../core/store/slices/settingSlice';
import { commonApi } from '../core/api/common.api';
import { useLocation } from 'react-router-dom';
import { MetaTags } from './metaSetting';
import LoadingModal from '../components/loadModal';
import AuthContext from '../core/context/AuthContext';
import { useEmbedConfig } from '../core/context/EmbedContext';
import ProductDetailModal from '../components/Cards/ProductDetailModal';
import { useGetAccessToken, useGetPrtnerInfo } from 'hooks/api';
import { buildPageTitle, getCompanyNameFromStoreInfo, getStoreInfoForPath } from 'utils';

const NormalLayout = (props: { children: any }) => {
  const dispatch = useDispatch();
  const embedConfig = useEmbedConfig();
  const hideChrome = Boolean(embedConfig?.hideChrome);
  const { token } = useContext(AuthContext);
  const [initalLoad, setInitialLoad] = useState(false);
  const filterDate = useSelector((state: any) => state.setting.filterDate);
  const cartItems = useSelector((state: any) => state.setting.cartItems);
  const partnerStore = useSelector((state: any) => state.setting.partnerStore);
  const selLocation = useSelector((state: any) => state.setting.selLocation);

  const { data: accessTokenData } = useGetAccessToken();
  const accessToken = accessTokenData?.data?.accessToken;

  const { data: partnerInfo } = useGetPrtnerInfo({ accessToken });

  useEffect(() => {
    if (partnerInfo?.data?.status === 'OK') {
      dispatch(setPartnerInfo(partnerInfo?.data));
    }
  }, [partnerInfo, dispatch]);

  const fetchPartnerStore = async () => {
    try{
		const { data } = await commonApi.getPartnerStore();
	    if (data && data.stores && data.status === "OK") {
	        const storeArray:any = {}
	        data.stores.forEach((store:any) => {
	          storeArray[store.url] = store;
	        });
	        dispatch(setPartnerStore(storeArray));
	      }
	} catch (e) {}
  };

  const fetchPartnerTrackingCode = async () => {
    try{
		const { data } = await commonApi.getPartnerTrackingCode();
	    if (data && data.codes && data.status === "OK") {
	        const codeArray:any = {}
	        data.codes.forEach((code:any) => {
	          codeArray[code.path] = code;
	        });
	        dispatch(setPartnerTrackCode(codeArray));
	      }
	} catch (e) {}
  };

  useEffect(() => {
    if (selLocation !== '') {
      const settingInfo = JSON.parse(window.localStorage.getItem("Setting") || '{}');
      window.localStorage.setItem(
        "Setting",
        JSON.stringify({
          ...settingInfo,
          location: selLocation
        })
      );
    }
  }, [selLocation]);

  useEffect(() => {
    if (filterDate) {
      const settingInfo = JSON.parse(window.localStorage.getItem("Setting") || '{}');
      window.localStorage.setItem(
        "Setting",
        JSON.stringify({
          ...settingInfo,
          dateFilter: {
          ...filterDate
          }
        })
      );
    }
  }, [filterDate]);

  useEffect(() => {
    const settingInfo = JSON.parse(window.localStorage.getItem("Setting") || '{}');
    window.localStorage.setItem(
      "Setting",
      JSON.stringify({
        ...settingInfo,
        cartItems: cartItems
      })
    );
  }, [cartItems]);

  useEffect(() => {
    if (token && !initalLoad) {
	    fetchPartnerStore();
	    fetchPartnerTrackingCode();
	    setInitialLoad(true);
    }
  }, [token]);

  const location = useLocation();
  const storeInfo = partnerStore[location.pathname];
  const bestStoreInfo = getStoreInfoForPath(partnerStore, location.pathname);
  const homeStoreInfo = partnerStore?.['/'];
  // Prefer company name from the home store listing; fall back to the current path's listing.
  // This avoids cases where /cart store records don't include brand/company fields.
  const companyName =
      getCompanyNameFromStoreInfo(homeStoreInfo) ||
      getCompanyNameFromStoreInfo(bestStoreInfo);

  const computedTitle = (() => {
      const path = location.pathname || '/';
      if (path === '/') return companyName;
      if (path.startsWith('/cart')) return buildPageTitle('Cart', companyName);
      // Product pages set their own dynamic title in the ProductDetail page.
      if (path.startsWith('/product/')) return undefined;
      return storeInfo && storeInfo.title;
  })();
	
  return (
    <div className={`flex flex-col justify-between min-h-screen overflow-hidden font bg-white text-14 `}>
      <div className="max-w-mxWidth mx-auto w-full">
        {!hideChrome && (
          <MetaTags
            title={computedTitle}
            description={storeInfo && storeInfo.description}
            keywords={storeInfo && storeInfo.keyword}
          />
        )}
        {!hideChrome && <Header />}
        {props.children}
      </div>
      {!hideChrome && <Footer />}
      <LoadingModal />
      <ProductDetailModal />
    </div>
  )
}

export default NormalLayout;